import React from 'react';

export default function Header({ isAuthenticated, currentLogo, orgName, currentUser, showUserDropdown, onLogoClick, onUserDropdownToggle, onLogout, onChangePassword }) {
  const handleLogoClick = () => {
    window.location.hash = '#/';
    if (onLogoClick) onLogoClick();
  };

  if (isAuthenticated) {
    return (
      <header className="app-header">
        <div className="header-content">
          <div className="header-left" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={handleLogoClick}>
            {currentLogo ? (
              <img 
                src={currentLogo.fullUrl || currentLogo.logoPath} 
                alt="Company Logo" 
                className="header-logo"
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <h1 className="header-title" style={{ cursor: 'pointer', margin: 0 }}>InvoiceMint</h1>
            )}
            {orgName && (
              <span style={{ marginLeft: '16px', color: '#666', fontSize: '14px' }}>
                {orgName}
              </span>
            )}
          </div>
          <div className="header-right" style={{ position: 'relative' }}>
            <div style={{ position: 'relative' }}>
              <button 
                onClick={() => onUserDropdownToggle(!showUserDropdown)} 
                title="User Menu" 
                className="user-menu-btn"
                style={{
                  background: '#fff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '6px',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#374151',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {currentUser?.name || 'User'}
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '4px', transform: showUserDropdown ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              {showUserDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  right: '0',
                  backgroundColor: '#fff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '6px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000,
                  minWidth: '180px',
                  marginTop: '4px'
                }}>
                  <button
                    onClick={onChangePassword}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: 'none',
                      background: 'none',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#111827',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      textAlign: 'left',
                      borderRadius: '6px',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1v4"/><path d="M12 19v4"/><path d="M4.22 4.22l2.83 2.83"/><path d="M16.95 16.95l2.83 2.83"/><path d="M1 12h4"/><path d="M19 12h4"/><path d="M4.22 19.78l2.83-2.83"/><path d="M16.95 7.05l2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg>
                    Change Password
                  </button>
                  <button
                    onClick={onLogout}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: 'none',
                      background: 'none',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#ef4444',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      textAlign: 'left',
                      borderRadius: '6px',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#fee2e2'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    );
  }

  // Unauthenticated header
  return (
    <header className="app-header">
      <div className="header-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div className="header-left" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <h1 className="header-title" style={{ margin: 0, cursor: 'pointer' }}>InvoiceMint</h1>
        </div>
        <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          <a href="#/features" style={{ color: '#374151', textDecoration: 'none', fontWeight: '500' }}>Features</a>
          <a href="#/contact" style={{ color: '#374151', textDecoration: 'none', fontWeight: '500' }}>Contact</a>
          <div style={{ display: 'flex', gap: '12px' }}>
            <a className="btn" href="#/login" style={{ padding: '8px 20px', border: '1px solid #d1d5db', borderRadius: '6px', textDecoration: 'none', color: '#374151', background: '#fff' }}>Login</a>
            <a className="btn btn-primary" href="#/register" style={{ padding: '8px 20px', borderRadius: '6px', textDecoration: 'none', color: '#fff', background: '#2563eb' }}>Register</a>
          </div>
        </div>
      </div>
    </header>
  );
}
